import { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  IconButton,
} from "@mui/material";

import Page from "../components/Page";
import Scrollbar from "../components/Scrollbar";
import SearchNotFound from "../components/SearchNotFound";
import Iconify from "../components/Iconify";

import HomePageMoreMenu from "../sections/reports/homePage/homePageMoreMenu";
import HomePageListToolbar from "../sections/reports/homePage/homePageListToolbar";
import HomePageListHead from "../sections/reports/homePage/homePageListhead";
import RenderArrayFields from "../components/RenderArrayFields";

const TABLE_HEAD = [
  { id: "title", label: "Title" },
  { id: "description", label: "Description" },
  { id: "newsTitle", label: "News Title" },
  { id: "newsTitleEvents", label: "News Events" },
  { id: "objectives", label: "Objectives" },
  { id: "upcommingTrainingsImage", label: "Upcoming Trainings" },
  { id: "upcommingTrainingsTitle", label: "Upcoming Training Title" },
  { id: "upcommingTrainingsTitleDescription", label: "Upcoming Training Description" },
  { id: "whatWeDoTitle", label: "What We Do Title" },
  { id: "whatWeDoTitleDescription", label: "What We Do Description" },
  { id: "whatWeDoCardData", label: "What We Do Cards" },
  { id: "testimonialsTitle", label: "Testimonials Title" },
  { id: "testimonials", label: "Testimonials" },
  { id: "action", label: "Action" },
];

export default function HomePage() {
  const [homePage, setHomePage] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filterName, setFilterName] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [editingHomePageId, setEditingHomePageId] = useState(null);
  const [selectedHomePage, setSelectedHomePage] = useState(null);

  const pageOptions = [
    { value: "/productivity", label: "Productivity Conclave" },
    { value: "/safety", label: "Safety Conclave" },
    { value: "/hr-conclave", label: "HR Conclave" },
    { value: "/skill-conclave", label: "Skill Conclave" },
    { value: "/quality", label: "Quality Conclave" },
    { value: "/other-conclave", label: "Other Conclave" },
    {value: "/training-programs", label: "Training Programs"},
  ];
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [newsTitle, setNewsTitle] = useState("");
  const [newsTitleEvents, setNewsTitleEvents] = useState([]);
  const [objectives, setObjectives] = useState([]);
  const [upcommingTrainingsImage, setUpcommingTrainingsImage] = useState([]);
  const [upcommingTrainingsTitle, setUpcommingTrainingsTitle] = useState("");
  const [upcommingTrainingsTitleDescription, setUpcommingTrainingsTitleDescription] = useState("");
  const [whatWeDoTitle, setWhatWeDoTitle] = useState("");
  const [whatWeDoTitleDescription, setWhatWeDoTitleDescription] = useState("");
  const [whatWeDoCardData, setWhatWeDoCardData] = useState([]);
  const [testimonialsTitle, setTestimonialsTitle] = useState("");
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    fetchHomePages();
  }, []);

  const fetchHomePages = async () => {
    const res = await axios.get("https://cpccbe.org/api/homepage/get-homepage");
    setHomePage(res.data.data || []);
  };

  const filteredHomePages = homePage.filter((item) =>
    item.title?.toLowerCase().includes(filterName.toLowerCase())
  );

  const isNotFound = filteredHomePages.length === 0;

  // const handleAddImageLink = () => {
  //   if (!imageInput.trim()) return;
  //   setUpcommingTrainingsImage([...upcommingTrainingsImage, imageInput.trim()]);
  //   setImageInput("");
  // };

  const handleRemoveImageLink = (index) => {
    setUpcommingTrainingsImage(upcommingTrainingsImage.filter((_, i) => i !== index));
  };

  const handleOpenModal = (row = null) => {
    if (row) {
      setTitle(row.title || '');
      setDescription(row.description || '');
      setNewsTitle(row.newsTitle || '');
      setNewsTitleEvents(row.newsTitleEvents || []);
      setObjectives(row.objectives || []);
      
      // Normalize images: ensure they are all objects { imgLink, page }
      const normalizedImages = (row.upcommingTrainingsImage || []).map(img => 
        typeof img === 'string' ? { imgLink: img, page: '' } : img
      );
      setUpcommingTrainingsImage(normalizedImages);
      
      setUpcommingTrainingsTitle(row.upcommingTrainingsTitle || '');
      setUpcommingTrainingsTitleDescription(row.upcommingTrainingsTitleDescription || '');
      setWhatWeDoTitle(row.whatWeDoTitle || '');
      setWhatWeDoTitleDescription(row.whatWeDoTitleDescription || '');
      setWhatWeDoCardData(row.whatWeDoCardData || []);
      setTestimonialsTitle(row.testimonialsTitle || '');
      setTestimonials(row.testimonials || []);
      setEditingHomePageId(row._id);
    } else {
      setTitle('');
      setDescription('');
      setNewsTitle('');
      setNewsTitleEvents([]);
      setObjectives([]);
      setUpcommingTrainingsImage([]);
      setUpcommingTrainingsTitle('');
      setUpcommingTrainingsTitleDescription('');
      setWhatWeDoTitle('');
      setWhatWeDoTitleDescription('');
      setWhatWeDoCardData([]);
      setTestimonialsTitle('');
      setTestimonials([]);
      setEditingHomePageId(null);
    }
    setOpenModal(true);
  };
    const handleCloseModal = () => {
    setTitle('');
      setDescription('');
      setNewsTitle('');
      setNewsTitleEvents([]);
      setObjectives([]);
      setUpcommingTrainingsImage([]);
      setUpcommingTrainingsTitle('');
      setUpcommingTrainingsTitleDescription('');
      setWhatWeDoTitle('');
      setWhatWeDoTitleDescription('');
      setWhatWeDoCardData([]);
      setTestimonialsTitle('');
      setTestimonials([]);
      setEditingHomePageId(null);
      setOpenModal(false);
  };

const handleAddImageRow = () => {
  setUpcommingTrainingsImage((prev) => [
    ...prev,
    { imgLink: "", page: "" }
  ]);
};

const handleUpdateImageField = (index, field, value) => {
  setUpcommingTrainingsImage((prev) => {
    const updated = [...prev];
    updated[index] = { ...updated[index], [field]: value };
    return updated;
  });
};



  const handleAddhomePage = async () => {
    try {
      const payload = {
        title,
        description,
        newsTitle,
        newsTitleEvents,
        objectives,
        upcommingTrainingsImage,
        upcommingTrainingsTitle,
        upcommingTrainingsTitleDescription,
        whatWeDoTitle,
        whatWeDoTitleDescription,
        whatWeDoCardData,
        testimonialsTitle,
        testimonials,
      };

      const response = await axios.post('https://cpccbe.org/api/homepage/create-homepage', payload);
      console.log('Add HomePage response:', response.data);
      alert('HomePage added successfully!');
      fetchHomePages();
      handleCloseModal();
      setOpenModal(false);
    } catch (error) {
      console.error('Error adding homepage:', error);
      alert(`Failed to add homepage: ${error.response?.data?.message || error.message}`);
    }
  };

  const handleUpdatehomePage = async () => {
    try {
      const payload = {
        title,
        description,
        newsTitle,
        newsTitleEvents,
        objectives,
        upcommingTrainingsImage,
        upcommingTrainingsTitle,
        upcommingTrainingsTitleDescription,
        whatWeDoTitle,
        whatWeDoTitleDescription,
        whatWeDoCardData,
        testimonialsTitle,
        testimonials,
      };

      const response = await axios.put(
        `https://cpccbe.org/api/homepage/update-homepage/${editingHomePageId}`,
        payload
      );
      console.log('Update HomePage response:', response.data);
      alert('HomePage updated successfully!');
      fetchHomePages();
      handleCloseModal();
      setOpenModal(false);
    } catch (error) {
      console.error('Error updating homepage:', error);
      alert(`Failed to update homepage: ${error.response?.data?.message || error.message}`);
    }
  };

  const handleDeletehomePage = async (id) => {
    if (window.confirm('Delete this homepage?')) {
      try {
        const response = await axios.delete(`https://cpccbe.org/api/homepage/delete-homepage/${id}`);
        console.log('Delete HomePage response:', response.data);
        alert('HomePage deleted successfully!');
        fetchHomePages();
      } catch (error) {
        console.error('Error deleting homepage:', error);
        alert(`Failed to delete homepage: ${error.response?.data?.message || error.message}`);
      }
    }
  };


  return (
    <Page title="HomePage">
      <Container>
        <Stack direction="row" justifyContent="space-between" mb={5}>
          <Typography variant="h4">HomePage</Typography>
          {/* ✅ FIXED: Added onClick handler */}
          <Button 
            variant="contained" 
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => handleOpenModal()}
          >
            New HomePage
          </Button>
        </Stack>

        <Card>
          <HomePageListToolbar
            filterName={filterName}
            onFilterName={(e) => setFilterName(e.target.value)}
          />

          <Scrollbar>
            <TableContainer>
              <Table>
                <HomePageListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {filteredHomePages
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow key={row._id}>
                        <TableCell>
                          <IconButton onClick={() => { setSelectedHomePage(row); setViewModalOpen(true); }}>
                            <Iconify icon="eva:eye-fill" />
                          </IconButton>
                        </TableCell>

                        <TableCell>{row.title}</TableCell>
                        <TableCell>{row.description}</TableCell>
                        <TableCell>{row.newsTitle}</TableCell>

                        <TableCell>
                          {row.newsTitleEvents?.map((e, i) => (
                            <div key={i}>{i + 1}. {e.title} — {e.link}</div>
                          ))}
                        </TableCell>

                        <TableCell>
                          {row.objectives?.map((o, i) => (
                            <div key={i}>{i + 1}. {o.title} — {o.description}</div>
                          ))}
                        </TableCell>

                        <TableCell>
                          {row.upcommingTrainingsImage?.map((img, i) => (
                            <div key={i}>
                              {typeof img === "string" ? (
                                img
                              ) : (
                                <a href={img.page} target="_blank" rel="noreferrer">
                                  {img.imgLink}
                                </a>
                              )}
                            </div>
                          ))}
                        </TableCell>

                        <TableCell align='left' sx={{ minWidth: 100 }}>{row.upcommingTrainingsImage?.map((item, index) => (
                            <div key={index}>
                              {index + 1}. {item.imgLink} - {item.page}
                            </div>
                          ))}</TableCell>
                        <TableCell align='left' sx={{ minWidth: 100 }}>{row.upcommingTrainingsTitle}</TableCell>
                        <TableCell align='left' sx={{ minWidth: 200 }}>{row.upcommingTrainingsTitleDescription}</TableCell>
                        <TableCell align='left' sx={{ minWidth: 100 }}>{row.whatWeDoTitle}</TableCell>
                        <TableCell align='left' sx={{ minWidth: 100 }}>{row.whatWeDoTitleDescription}</TableCell>
                        <TableCell align="left" sx={{ minWidth: 400 }}>
                          {row.whatWeDoCardData?.map((item, index) => (
                            <div key={index}>
                              {index + 1}. {item.title} — {item.content} — {item.link}
                            </div>
                          ))}
                        </TableCell>

                        <TableCell>{row.testimonialsTitle}</TableCell>

                        <TableCell>
                          {row.testimonials?.map((t, i) => (
                            <div key={i}>{i + 1}. {t.title}</div>
                          ))}
                        </TableCell>

                        <TableCell>
                          {/* ✅ FIXED: Pass handlers to HomePageMoreMenu */}
                          <HomePageMoreMenu 
                            onEdit={() => handleOpenModal(row)}
                            onDelete={() => handleDeletehomePage(row._id)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}

                  {isNotFound && (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={homePage.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            onRowsPerPageChange={(e) => setRowsPerPage(+e.target.value)}
          />
        </Card>

        {/* CREATE / EDIT MODAL */}
       <Dialog open={openModal} onClose={() => {handleCloseModal(); setOpenModal(false);}} maxWidth="md" fullWidth>
  <DialogTitle>
    {editingHomePageId ? "Edit HomePage" : "New HomePage"}
  </DialogTitle>

  <DialogContent dividers>

    {/* Basic Info */}
    <TextField
      fullWidth
      margin="dense"
      label="Title"
      value={title}
      onChange={(e) => setTitle(e.target.value)}
    />

    <TextField
      fullWidth
      multiline
      rows={3}
      margin="dense"
      label="Description"
      value={description}
      onChange={(e) => setDescription(e.target.value)}
    />

    {/* News */}
    <TextField
      fullWidth
      margin="dense"
      label="News Title"
      value={newsTitle}
      onChange={(e) => setNewsTitle(e.target.value)}
    />

    <RenderArrayFields
      label="News Events"
      data={newsTitleEvents}
      setData={setNewsTitleEvents}
      fields={["title", "link"]}
    />

    {/* Objectives */}
    <RenderArrayFields
      label="Objectives"
      data={objectives}
      setData={setObjectives}
      fields={["title", "description", "link"]}
    />

    {/* Upcoming Trainings */}
    <Typography variant="subtitle1" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
      Upcoming Training Images
    </Typography>
    
    {upcommingTrainingsImage.map((item, index) => (
      <Box key={index} sx={{ border: "1px solid #ddd", p: 2, mt: 2, borderRadius: 1, position: 'relative', bgcolor: '#f9f9f9' }}>
        <Typography variant="caption" sx={{ position: 'absolute', top: -10, left: 10, bgcolor: 'white', px: 1 }}>
          Image #{index + 1}
        </Typography>
        
        <TextField
          fullWidth
          margin="dense"
          label="Image URL"
          value={item.imgLink || ""}
          onChange={(e) => handleUpdateImageField(index, "imgLink", e.target.value)}
        />
        
        <FormControl fullWidth margin="dense">
          <InputLabel id={`page-select-label-${index}`}>Select Page Link</InputLabel>
          <Select
            labelId={`page-select-label-${index}`}
            value={item.page || ""}
            label="Select Page Link"
            onChange={(e) => handleUpdateImageField(index, "page", e.target.value)}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {pageOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button 
          color="error" 
          size="small" 
          startIcon={<Iconify icon="eva:trash-2-outline" />}
          onClick={() => handleRemoveImageLink(index)}
          sx={{ mt: 1 }}
        >
          Remove Image
        </Button>
      </Box>
    ))}

    <Button
      variant="outlined"
      startIcon={<Iconify icon="eva:plus-fill" />}
      sx={{ mt: 2 }}
      onClick={handleAddImageRow}
    >
      Add Training Image
    </Button>

    <Box sx={{ mt: 3 }}>
      <TextField
        fullWidth
        margin="dense"
        label="Upcoming Training Title"
        value={upcommingTrainingsTitle}
        onChange={(e) => setUpcommingTrainingsTitle(e.target.value)}
      />

      <TextField
        fullWidth
        multiline
        rows={2}
        margin="dense"
        label="Upcoming Training Description"
        value={upcommingTrainingsTitleDescription}
        onChange={(e) => setUpcommingTrainingsTitleDescription(e.target.value)}
      />
    </Box>

    {/* What We Do */}
    <TextField
      fullWidth
      margin="dense"
      label="What We Do Title"
      value={whatWeDoTitle}
      onChange={(e) => setWhatWeDoTitle(e.target.value)}
    />

    <TextField
      fullWidth
      multiline
      rows={2}
      margin="dense"
      label="What We Do Description"
      value={whatWeDoTitleDescription}
      onChange={(e) => setWhatWeDoTitleDescription(e.target.value)}
    />

    <RenderArrayFields
      label="What We Do Cards"
      data={whatWeDoCardData}
      setData={setWhatWeDoCardData}
      fields={["title", "content", "link"]}
    />

    {/* Testimonials */}
    <TextField
      fullWidth
      margin="dense"
      label="Testimonials Title"
      value={testimonialsTitle}
      onChange={(e) => setTestimonialsTitle(e.target.value)}
    />

    <RenderArrayFields
      label="Testimonials"
      data={testimonials}
      setData={setTestimonials}
      fields={["title", "description", "role"]}
    />

  </DialogContent>

  <DialogActions>
            <Button onClick={handleCloseModal}>Cancel</Button>
            {editingHomePageId ? (
              <Button onClick={handleUpdatehomePage}>Update HomePage</Button>
            ) : (
              <Button onClick={handleAddhomePage}>Add HomePage</Button>
            )}
          </DialogActions>
</Dialog>


        {/* VIEW MODAL */}
       <Dialog
  open={viewModalOpen}
  onClose={() => setViewModalOpen(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>HomePage Details</DialogTitle>

  <DialogContent dividers>
    {selectedHomePage && (
      <Box>

        {/* Title */}
        <Typography variant="subtitle2">Title</Typography>
        <Typography>{selectedHomePage.title || "-"}</Typography>

        {/* Description */}
        <Typography variant="subtitle2" mt={2}>Description</Typography>
        <Typography>{selectedHomePage.description || "-"}</Typography>

        {/* News */}
        <Typography variant="subtitle2" mt={2}>News</Typography>
        <Typography>{selectedHomePage.newsTitle || "-"}</Typography>

        {Array.isArray(selectedHomePage.newsTitleEvents) &&
          selectedHomePage.newsTitleEvents.map((item, index) => (
            <Typography key={index} variant="body2" sx={{ ml: 1 }}>
              {index + 1}. {item.title} —{" "}
              <a href={item.link} target="_blank" rel="noreferrer">
                {item.link}
              </a>
            </Typography>
          ))
        }

        {/* Objectives */}
        <Typography variant="subtitle2" mt={2}>Objectives</Typography>
        {Array.isArray(selectedHomePage.objectives) &&
          selectedHomePage.objectives.map((item, index) => (
            <Typography key={index} variant="body2" sx={{ ml: 1 }}>
              {index + 1}. {item.title} — {item.description} —{" "}
              <a href={item.link} target="_blank" rel="noreferrer">
                {item.link}
              </a>
            </Typography>
          ))
        }

        {/* Upcoming Trainings */}
        <Typography variant="subtitle2" mt={2}>
          Upcoming Training
        </Typography>

        {selectedHomePage?.upcommingTrainingsImage?.map((img, i) => (
          <Box key={i} mt={1}>
            {typeof img === "string" ? (
              <img
                src={img}
                alt={`training-${i}`}
                width={120}
                style={{ borderRadius: 6 }}
              />
            ) : (
              <a href={img.page} target="_blank" rel="noreferrer">
                <img
                  src={img.imgLink}
                  alt={`training-${i}`}
                  width={120}
                  style={{ borderRadius: 6 }}
                />
              </a>
            )}
          </Box>
        ))}

        <Typography>
          {selectedHomePage.upcommingTrainingsTitle || "-"}
        </Typography>

        <Typography variant="body2">
          {selectedHomePage.upcommingTrainingsTitleDescription || "-"}
        </Typography>

        {/* What We Do */}
        <Typography variant="subtitle2" mt={2}>What We Do</Typography>

        <Typography>
          {selectedHomePage.whatWeDoTitle || "-"}
        </Typography>

        <Typography variant="body2">
          {selectedHomePage.whatWeDoTitleDescription || "-"}
        </Typography>

        {Array.isArray(selectedHomePage.whatWeDoCardData) &&
          selectedHomePage.whatWeDoCardData.map((item, index) => (
            <Typography key={index} variant="body2" sx={{ ml: 1 }}>
              {index + 1}. {item.title} — {item.content} —{" "}
              <a href={item.link} target="_blank" rel="noreferrer">
                {item.link}
              </a>
            </Typography>
          ))
        }

        {/* Testimonials */}
        <Typography variant="subtitle2" mt={2}>
          Testimonials
        </Typography>

        <Typography>
          {selectedHomePage.testimonialsTitle || "-"}
        </Typography>

        {Array.isArray(selectedHomePage.testimonials) &&
          selectedHomePage.testimonials.map((item, index) => (
            <Typography key={index} variant="body2" sx={{ ml: 1 }}>
              {index + 1}. {item.title} — {item.description} ({item.role})
            </Typography>
          ))
        }

      </Box>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setViewModalOpen(false)}>Close</Button>
  </DialogActions>
</Dialog>

      </Container>
    </Page>
  );
}